import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AngularUiModule,
  DestroyAbleComponent,
  ScreenSizeService,
} from '@univacity/angular/ui';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  EDUCATION_LEVEL,
  ORGANISATION_TYPE,
  Option,
  RoutePath,
} from '@univacity/shared/types';
import { ObjectUtil, StringUtil } from '@univacity/shared/util';
import {
  AnalyticsService,
  CountryService,
  OrganisationService,
  ProgramService,
  TRACKED_EVENTS,
  TourService,
} from '@univacity/angular/datas';
import { Params, Router } from '@angular/router';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMessageService } from 'ng-zorro-antd/message';

export type Selected =
  | 'programs'
  | 'institutes'
  | 'tours'
  | 'hostels'
  | 'flights'
  | 'visa';

@Component({
  selector: 'un-search-drawer',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AngularUiModule,
    NzDropDownModule,
  ],
  templateUrl: './search-drawer.component.html',
  styleUrls: ['./search-drawer.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchDrawerComponent
  extends DestroyAbleComponent
  implements OnInit
{
  selected: Selected = 'programs';
  heading = 'What are you looking for?';

  levels: Option[] = Object.values(EDUCATION_LEVEL)
    .filter(
      (v) => ![EDUCATION_LEVEL.PRIMARY, EDUCATION_LEVEL.HIGH_SCHOOL].includes(v)
    )
    .map((l) => ({
      label: StringUtil.toTitleCase(l),
      value: l,
    }));
  instituteTypes = ObjectUtil.enumToKeyLabelValuePair(ORGANISATION_TYPE);

  programsForm: FormGroup;
  institutesForm: FormGroup;
  toursForm: FormGroup;
  visaForm: FormGroup;
  hostelsForm: FormGroup;
  flightsForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    public programService: ProgramService,
    public countryService: CountryService,
    public organisationService: OrganisationService,
    public tourService: TourService,
    private analytics: AnalyticsService,
    public screen: ScreenSizeService,
    private drawer: NzDrawerRef,
    private message: NzMessageService,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.initForms();
  }
  initForms() {
    this.programsForm = this.fb.group({
      search: ['', [Validators.required]],
      level: ['', [Validators.required]],
      country: [''],
    });
    this.institutesForm = this.fb.group({
      type: [''],
      country: [''],
    });
    this.toursForm = this.fb.group({
      search: ['', [Validators.required]],
      country: [''],
    });
    this.visaForm = this.fb.group({
      search: ['', [Validators.required]],
      citizenship: [''],
      country: ['', [Validators.required]],
    });
  }

  search() {
    let queryParams: Params = {};
    let route: RoutePath | string = RoutePath.programsSearch;
    switch (this.selected) {
      case 'programs': {
        queryParams = this.programsForm.value;
        this.analytics.track(TRACKED_EVENTS.programsSearch, queryParams);
        break;
      }
      case 'institutes': {
        queryParams = this.institutesForm.value;
        route = RoutePath.organisationsSearch;
        break;
      }
      case 'tours': {
        queryParams = this.toursForm.value;
        route = RoutePath.toursSearch;
        break;
      }
      case 'visa': {
        if (!this.visaForm.value.country) {
          this.message.error($localize`Please input destination`);
          return;
        }
        route =
          `/${RoutePath.visa}` +
          `/${this.visaForm.value.country}` +
          `/${this.visaForm.value.citizenship || 'NG'}`;
        break;
      }
    }
    this.router.navigate([route], {
      queryParams: ObjectUtil.removeEmptyProperties(queryParams),
    });
    this.drawer.close();
  }
}
